const TABLE_HEAD = ["Data", "Spektakl", "Gdzie", "Zarezerwuj"];

const TABLE_ROWS = [
{
  name: "3",
  miesiac: "Września",
  projekt: "",
  spetakl: "Matecznik - 19:00",
  date: "Teatr Łątek Supraśl",
//  link: "",
  tekst: "",
},
{
  name: "5",
  miesiac: "Września",
  projekt: "",
  spetakl: "Matecznik - 18:00",
  date: "Teatr Łątek Supraśl",
  //link: "",
  tekst: "",
},
{
  name: "11",
  miesiac: "Września",
  projekt: "",
  spetakl: "Matecznik - 18:00",
  date: "Morskie Oko 2, Warszawa",
  locationName: "Scena96",
  locationLink: "https://www.facebook.com/teatrscena96",
  //link: "",
  tekst: "",
},
{
  name: "25",
  miesiac: "Września",
  projekt: "w ramach BytOFFsky Festival",
  spetakl: "Nosferatu – dziennik zarazy - 17:00",
  date: "",
 // link: "",
  tekst: "",
},
];

export { TABLE_HEAD, TABLE_ROWS };
